/**
 * 计算圆角矩形面积
 * @param w 圆角矩形的宽度(!包括圆角部分)
 * @param h 圆角矩形的高度(!包括圆角部分)
 * @param r 圆角矩形的圆角半径
 * @returns 面积=(w-2r)(h-2r)+2r(w-2r)+2r(h-2r)+pi*r^2 化简后=wh-4r^2+pi*r^2
 */
export const roundedRectArea = (w: number, h: number, r: number): number =>
  w * h - 4 * r * r + Math.PI * r * r;

/**
 * 帧间隔转每秒帧数
 * @param interval 帧间隔
 * @returns fps=1000/interval
 */
export const interval2fps = (interval: number): number => 1000 / interval;

/**
 * 每秒帧数转帧间隔
 * @param fps 每秒帧数
 * @returns interval=1000/fps
 */
export const fps2interval = (fps: number): number => 1000 / fps;
